<template>
    <div>
        <multiselect v-model="value" placeholder="Search a tag" :label="label_multiselect"  track-by="id" :options="list" :disabled="disabled" :multiple="true" :taggable="true" @input="selectTag"></multiselect>
        <!-- <input type="hidden" name="contractualItemPerson[person_id]" :value="this.selectedPerson.id"> -->
        <div class="categoriesList">
            <input v-for="tag in value" type="hidden" :name="name_input_prop" :value="tag.id">
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    components: {
        Multiselect
    },
    mounted() {
        if (this.tags_url) {
            axios.get(this.tags_url).then(response => {
                this.list = response.data;
            });
        } else {
            this.list = this.tags_prop;
        }
        this.value = this.tags_selected_prop;
    },
    data () {
        return {
            value: [],
            list: [],
        }
    },
    methods: {

        setExternalTags(list){
          this.list = list;
        },
        selectTag (tagList) {
            this.value = tagList
        }
    },
    props: {
        tags_url: {
            type: String,
            required: false,
            default: null
        },
        tags_prop: {
            type: Array,
            required: false,
            default: () => []
        },
        name_input_prop:{
            type: String,
            required: true
        },
        tags_selected_prop:{

            type: Array,
            required : true
        },
        label_multiselect:{
            type: String,
            required : false,
            default:"name"
        },
        disabled :{
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style>
  /*.custom-actions button.ui.button {
    padding: 8px 8px;
  }
  .custom-actions button.ui.button > i.icon {
    margin: auto !important;
  }*/
</style>
